import {observer} from "mobx-react";
import styled from "@emotion/styled";
import React, {Fragment} from "react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {IFiltersController} from "views/components/filters/filters.controller";
import {css} from "@emotion/react";
import {Button, Stack} from "@mui/material";

const Wrapper = styled.div<{isOpen?: boolean}>`
	height: 100%;
	background: #eeeeef;
	display: flex;
	transform: translateX(-100%);
	transition: transform 0.5s ease;
	position: absolute;
	left: 100%;
	max-width: calc(100vw - 180px);
	overflow: scroll;
	top: 0;
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
	scroll-snap-type: x mandatory;
	opacity: 0;
	&::-webkit-scrollbar {
		display: none;
	}

	@media (max-width: 768px) {
		display: none;
	}
	${(props) =>
		props.isOpen &&
		css`
			opacity: 1;
			transform: translateX(0);
			transition: transform 0.5s ease;
		`}
`;

const Column = styled.div`
	display: flex;
	flex-flow: column;
	gap: 4px;
	min-width: 95px;
	font-family: var(--fontFamilySecond);
	font-size: 11px;
	color: #302f31;
	font-weight: 500;
	text-transform: uppercase;
	text-align: center;
	line-height: 150%;
	padding: 8px;
	white-space: nowrap;

	p {
		font-weight: 600;
	}
`;

interface IProps {
	isOpen: boolean;
}
export const FiltersComponent: React.FC<IProps> = observer(({isOpen}) => {
	const controller = useViewController<IFiltersController>(Bindings.FiltersController);
	const i18n = controller.i18n;

	return (
		<Wrapper isOpen={isOpen}>
			<Column>
				<p>{i18n.t("widget.filter.preseason", "preseason")}</p>

				<Stack>
					{controller.preSeasonList.map((round) => (
						<Button
							variant={"text"}
							key={round.name}
							size={"small"}
							onClick={() => controller.onSelectRound(round.id)}
							color={controller.isSelected(round) ? "secondary" : undefined}>
							{i18n.t(
								"widget.filter.preseason_week",
								`preseason ${
									controller.preSeasonNameMap[round.number] || round.number
								}`,
								{X: controller.preSeasonNameMap[round.number] || round.number}
							)}
						</Button>
					))}
				</Stack>
			</Column>

			{controller.regularSeasonRounds.map((chunkedRounds, index) => (
				<Column key={index}>
					<p>
						{index === 0 ? (
							<Fragment>{i18n.t("widget.filter.regular", "regular")}</Fragment>
						) : (
							<Fragment>&nbsp;</Fragment>
						)}
					</p>

					<Stack>
						{chunkedRounds.map((round) => (
							<Button
								variant={"text"}
								key={round.id}
								size={"small"}
								onClick={() => controller.onSelectRound(round.id)}
								color={controller.isSelected(round) ? "secondary" : undefined}>
								{i18n.t("widget.filter.week", `week ${round.number}`, {
									X: round.number,
								})}
							</Button>
						))}
					</Stack>
				</Column>
			))}

			<Column>
				<p>{i18n.t("widget.filter.playoffs", "playoffs")}</p>

				<Stack>
					{controller.playoffsList.map((round) => (
						<Button
							variant={"text"}
							key={round.name}
							size={"small"}
							onClick={() => controller.onSelectRound(round.id)}
							color={controller.isSelected(round) ? "secondary" : undefined}>
							{i18n.t("widget.filter.week", `week ${round.number}`, {
								X: round.number,
							})}
						</Button>
					))}
				</Stack>
			</Column>
		</Wrapper>
	);
});
